
import { useMemo } from 'react';

import { AgreementReadModel } from '@client/api';
import { combineStrings } from '@client/toolkit';

export const useAgreementSpacesAdressesNumerationTexts = (
  agreement: AgreementReadModel | undefined | null
): string[] | undefined => {
  const texts = useMemo(() => {
    if (
      agreement == null ||
      agreement.spaces == null ||
      !Array.isArray(agreement.spaces) ||
      agreement.spaces.length <= 0
    ) {
      return undefined;
    }

    return agreement.spaces.map((x) => (
      // combineStrings(' - ', x.space.address.formattedAddress, x.space.name) ?? ''
      x.space.name ?? ''
    ));
  }, [agreement]);

  return texts;
};
